import { Action } from '@/types/actions';
import { validateRecurrence } from '@/utils/events';

export function actionHasRecurrenceForbiddenInBlock(action: Action | null | undefined): boolean {
  return validateRecurrence(action?.event?.recurrence);
}
